import type { StateCreator } from 'zustand'

/** Toggle do painel de validação IDS, sobre o canvas. O relatório vive
 *  no estado do componente; aqui só persistimos o aberto/fechado para o
 *  botão do ribbon refletir. Espelha o IfcDiffSlice. */
export interface IdsSlice {
  idsPanelOpen: boolean
  setIdsPanelOpen: (open: boolean) => void
  // Canal de pré-preenchimento do painel IDS: um ficheiro .ids (texto XML
  // + nome) que o painel adota ao render e depois limpa. Usado pela
  // ligação partilhável (?ids=https://...) para abrir o painel já com as
  // regras carregadas. Espelha o filterPrefill do ViewerSlice.
  idsPrefill: { xml: string; name: string } | null
  setIdsPrefill: (p: { xml: string; name: string } | null) => void
}

export const createIdsSlice: StateCreator<IdsSlice> = (set) => ({
  idsPanelOpen: false,
  setIdsPanelOpen: (open) => set({ idsPanelOpen: open }),
  idsPrefill: null,
  setIdsPrefill: (p) => set({ idsPrefill: p }),
})
